// extracted by mini-css-extract-plugin
export default {"danzig":"home_danzig__cL9Xf","p":"home_p__sV80T","home":"home_home__1jket","mobileHome":"home_mobileHome__FBEB2","mobileLogo":"home_mobileLogo__27VwH"};